import React, { ReactNode } from 'react';
import { useState } from 'react';
import classNames from 'classnames';

import {
  Button,
  HomeCarousel,
  IconArrowLeft,
  IconArrowRight
} from '@sympla/sympla-components';
import { CardTypes } from 'types/CardTypes';
import { cardVariants, variantCarousel } from 'constants/search';

import * as styles from './CarouselNavigator.css';

export function CarouselNavigator({
  carouselOptions,
  typeCarousel,
  typeCard,
  idCarousel,
  colorArrowVariant
}: {
  carouselOptions: Array<{ slide: ReactNode }>;
  typeCarousel: CardTypes;
  typeCard?: string;
  idCarousel: string;
  colorArrowVariant?: string;
}) {
  const [controls, setControls] = useState<{
    next?: () => void;
    prev?: () => void;
    slidesTotal: number;
  }>({
    next: () => null,
    prev: () => null,
    slidesTotal: 0
  });
  const [btnArrows, setBtnArrows] = useState({
    beginning: true,
    end: false
  });
  const showRightArrow = carouselOptions.length >= 4;

  const getClassNamesButton = (isPrev: boolean) => {
    return classNames(styles.arrowButtonBaseStyle, {
      [styles.arrowButtonPrev]: isPrev,
      [styles.arrowButtonNext]: !isPrev,
      [styles.highlightedEventsArrowButton]:
        typeCard === cardVariants.eventCardHighlight,
      [styles.top10EventsArrowButton]: typeCard === variantCarousel.top10Events,
      [styles.arrowButtonMoss]: colorArrowVariant === variantCarousel.arrowMoss
    });
  };

  return (
    <div className={styles.carouselFlexContainer}>
      <div className={styles.sectionContainerButtonsIcons}>
        <Button
          variant="text"
          icon={<IconArrowLeft width={20} height={20} />}
          onClick={controls.prev}
          disabled={btnArrows.beginning}
          aria-label="Previous"
          className={getClassNamesButton(true)}
        />
        {showRightArrow && (
          <Button
            variant="text"
            icon={<IconArrowRight width={20} height={20} />}
            onClick={controls.next}
            disabled={btnArrows.end}
            aria-label="Next"
            className={getClassNamesButton(false)}
          />
        )}
      </div>
      <HomeCarousel
        type={typeCarousel}
        options={carouselOptions}
        id={idCarousel}
        controls={(payload) => setControls((prev) => ({ ...prev, ...payload }))}
        updateArrows={(payload) => setBtnArrows(payload)}
      />
    </div>
  );
}
